<template>
  <div>
    <div
      class="mobile-filter-icon"
      v-if="checkMobileFilterBtn"
      @click="scrollUp"
    >
      <img
        src="../../../Assets/Images/filter-icon.svg"
        alt="filter"
        @click="checkMobileFilter"
      />
    </div>
    <aside class="filter" v-if="checkMobileFilterData">
      <section
        class="filter-datepicker "
        v-if="checkCat == 'regulation' || checkCat == 'announce'"
      >
        <div
          class="checkbox-parent"
          v-if="checkCat == 'regulation' || checkCat == 'announce'"
        >
          <div class="gold-link" @click="checkMobileFilter">
            {{ BackBtn }} >
          </div>
        </div>
      </section>
      <section>
          <div class="checkbox-parent" v-if="checkCat == 'service'">
              <div class="gold-link" @click="checkMobileFilter">
                  {{ BackBtn }} >
              </div>
          </div>
          <h4 class="title"
              v-if="
            checkCat == 'service' ||
              (checkCat == 'announce' && apiResponse.Categories)
          ">
              {{ categoryLab }}
          </h4>
          <ul class="main-menu"
              v-if="
            checkCat == 'service' ||
              (checkCat == 'announce' && apiResponse.Categories)
          ">
              <li v-for="(item, index) in apiResponse.Categories" :key="index">
                  <div class="checkbox-parent">
                      <label class="custom-checkbox">
                          <input type="checkbox"
                                 @click="selectAll('categories', $event, index)"
                                 v-model="item.checked" />
                          <span class="custom-checkbox__img border-color">
                              <img src="../../../Assets/Images/checked-icon.png" alt="icon" />
                          </span>
                      </label>
                      <span class="toggle-second-menu">
                          {{ item.CategoryName }}
                          <a data-toggle="collapse"
                             :href="'#' + index"
                             role="button"
                             aria-expanded="false"
                             :aria-controls="index"
                             class="collapsed">
                              <i v-if="item.SubCategories.length != 0"
                                 class="clickable-btn icon-arrow-down">
                              </i>
                          </a>
                      </span>
                  </div>
                  <ul class="second-level multi-collapse collapse"
                      :id="index"
                      v-if="item.SubCategories.length != 0">
                      <li v-for="(subItem, indexs) in item.SubCategories" :key="indexs">
                          <label class="custom-checkbox">
                              <input type="checkbox"
                                     v-model="subItem.checked"
                                     @click="select('categories', index, $event, indexs)" />
                              <span class="custom-checkbox__img">
                                  <img src="../../../Assets/Images/checked-icon.png" alt="icon" />
                              </span>
                              <span> {{ subItem.value }}</span>
                          </label>
                      </li>
                  </ul>
              </li>
          </ul>

          <!-- Categ Regulations -->
          <h4 class="title" v-if="checkCat == 'regulation' && categRegulation">
              {{ CategoriesOfRules }}
          </h4>
          <ul class="main-menu"
              v-if="checkCat == 'regulation' && categRegulation">
              <li v-for="(item, index) in categRegulation" :key="index">
                  <div class="checkbox-parent">
                      <label class="custom-checkbox">
                          <input type="checkbox"
                                 v-model="item.checked"
                                 @click="selectAll('ruleCategories', $event, index)" />
                          <span class="custom-checkbox__img border-color">
                              <img src="../../../Assets/Images/checked-icon.png" alt="icon" />
                          </span>
                      </label>
                      <span class="toggle-second-menu">{{ item.CategoryName }} </span>
                  </div>
              </li>
          </ul>
          <!-- second section -->
          <div v-if="checkSector">
              <h4 class="title" v-if="apiResponse.Sectors">
                  {{ sectorLab }}
              </h4>

              <ul class="main-menu" v-if="apiResponse.Sectors">
                  <li v-for="(item, index) in apiResponse.Sectors" :key="index">
                      <div class="checkbox-parent">
                          <label class="custom-checkbox">
                              <input type="checkbox"
                                     @click="selectAll('sectors', $event, index)"
                                     v-model="item.checked" />
                              <span class="custom-checkbox__img border-color">
                                  <img src="../../../Assets/Images/checked-icon.png" alt="icon" />
                              </span>
                          </label>
                          <span class="toggle-second-menu">
                              {{ item.Name }}
                              <a data-toggle="collapse"
                                 :href="'#a' + index"
                                 role="button"
                                 aria-expanded="false"
                                 :aria-controls="'a' + index"
                                 class="collapsed">
                                  <i class="clickable-btn icon-arrow-down"
                                     v-if="item.Department.length != 0">
                                  </i>
                              </a>
                          </span>
                      </div>
                      <ul class="second-level multi-collapse collapse"
                          :id="'a' + index"
                          v-if="item.Department.length != 0">
                          <li v-for="(subItem, indexs) in item.Department" :key="indexs">
                              <label class="custom-checkbox">
                                  <input type="checkbox"
                                         v-model="subItem.checked"
                                         @click="select('sectors', index, $event, indexs)" />
                                  <span class="custom-checkbox__img">
                                      <img src="../../../Assets/Images/checked-icon.png" alt="icon" />
                                  </span>
                                  <span> {{ subItem.value }}</span>
                              </label>
                          </li>
                      </ul>
                  </li>
              </ul>
          </div>
          <!-- third section -->

          <h4 class="title" v-if="apiResponse.HealthProducts">
              {{ productLab }}
          </h4>
          <ul class="main-menu" v-if="apiResponse.HealthProducts">
              <li v-for="(item, index) in apiResponse.HealthProducts" :key="index">
                  <div class="checkbox-parent">
                      <label class="custom-checkbox">
                          <input type="checkbox"
                                 @click="selectAll('health', $event, index)"
                                 v-model="item.checked" />
                          <span class="custom-checkbox__img border-color">
                              <img src="../../../Assets/Images/checked-icon.png" alt="icon" />
                          </span>
                      </label>
                      <span class="toggle-second-menu">{{ item.Name }} </span>
                  </div>
              </li>
          </ul>

          <!-- fourth section -->

          <h4 class="title" v-if="apiResponse.Functions">
              {{ functionsLab }}
          </h4>
          <ul class="main-menu" v-if="apiResponse.Functions">
              <li v-for="(item, index) in apiResponse.Functions" :key="index">
                  <div class="checkbox-parent">
                      <label class="custom-checkbox">
                          <input type="checkbox"
                                 @click="selectAll('func', $event, index)"
                                 v-model="item.checked" />
                          <span class="custom-checkbox__img border-color">
                              <img src="../../../Assets/Images/checked-icon.png" alt="icon" />
                          </span>
                      </label>
                      <span class="toggle-second-menu">{{ item.Name }} </span>
                  </div>
              </li>
          </ul>

          <div class="btns-wrapper-filter">
              <button class="custom-btn"
                      :class="filterClicked ? 'dimmet' : ''"
                      @click.prevent="sendData(), filter()">
                  {{ Apply }}
              </button>
              <button class="custom-btn" @click.prevent="reset()">
                  {{ Reset }}
              </button>
          </div>
      </section>
    </aside>
  </div>
</template>
<script>
import Vue from "vue";
import DatePicker from "v-calendar/lib/components/date-picker.umd";

Vue.component("v-date-picker", DatePicker);

export default {
  name: "filterservice",
  data() {
    return {
      allSelectedCate: false,
      cateArr: [],
      sectorArr: [],
      subArr: [],
      healthArr: [],
      funcArr: [],
      depArr: [],
      userIds: [],
      tarckApplyFilter: false,
      checkMobileFilterBtn: false,
      checkMobileFilterData: true,
      checkedUsers: [],
      info: [],
      ruleCateg: [],
      ruleArr: [],
      counter: 0
    };
  },
  props: [
    "Apply",
    "Reset",
    "checkSector",
    "apiResponse",
    "filter",
    "categoryLab",
    "sectorLab",
    "productLab",
    "functionsLab",
    "checkCat",
    "categRegulation",
    "CategoriesOfRules",
    "FilterByDate",
    "ClearDateFilter",
    "filterClicked",
    "From",
    "To",
    "Required",
    "BackBtn",
  ],
  methods: {
    handleSelectAll(e, index) {

        let category = this.apiResponse.Categories;
        for(let i=1;i <category.length; i++) {
          if (!this.cateArr.includes(category[i].CategoryName)) {
            this.cateArr.push(category[i].CategoryName);
          } else {
            let filtered = this.cateArr.filter(function(value) {
              return value != category[i].CategoryName;
            });
            this.cateArr = filtered;
          }
          for (let categ of category[i].SubCategories) {
            if (e.target.checked) {
              categ.checked = true;
              if (!this.subArr.includes(categ.value)) {
                this.subArr.push(categ.value);
              }
            } else {
              categ.checked = false;
              let filtered = this.subArr.filter(function(value) {
                return value != categ.value;
              });
              this.subArr = filtered;
            }
          }
        }

        let sector = this.apiResponse.Sectors;

        for(let x=0;x <sector.length; x++) {
          if (!this.sectorArr.includes(sector[x].Name)) {
            this.sectorArr.push(sector[x].Name);
          } else {
            let filtered = this.sectorArr.filter(function(value) {
              return value != sector[x].Name;
            });
            this.sectorArr = filtered;
          }

          for (let sec of sector[x].Department) {
            if (e.target.checked) {
              sec.checked = true;
              if (!this.depArr.includes(sec.value)) {
                this.depArr.push(sec.value);
              }
            } else {
              sec.checked = false;
              let filtered = this.depArr.filter(function(value) {
                return value != sec.value;
              });
              this.depArr = filtered;
            }
          }
        }
        
        let health = this.apiResponse.HealthProducts[index];
        if (!this.healthArr.includes(health?.Name)) {
          this.healthArr.push(health?.Name);
        } else {
          let deletedItem = this.healthArr.indexOf(health?.Name);
          this.healthArr.splice(deletedItem, 1);
        }


        let func = this.apiResponse.Functions[index];
        if (!this.funcArr.includes(func?.Name)) {
          this.funcArr.push(func?.Name);
        } else {
          let deletedItem = this.funcArr.indexOf(func?.Name);
          this.funcArr.splice(deletedItem, 1);
        }

        let rule;
        if(this.categRegulation) {
          rule = this.categRegulation[index];
          if (!this.ruleArr.includes(rule?.CategoryName.trim())) {
            this.ruleArr.push(rule?.CategoryName.trim());
          } else {
            let deletedItem = this.ruleArr.indexOf(rule?.CategoryName.trim());
            this.ruleArr.splice(deletedItem, 1);
          }
        }
        
      

      for (let categ in this.apiResponse) {
        var obj = this.apiResponse[categ];
        if(obj?.length) {
          for(let sub of obj) {
            if (e.target.checked) {
              sub?.checked ? sub.checked = true:sub.checked = true;
            } else {
              sub?.checked ? sub.checked = false:sub.checked = false;
            }
            if(sub?.SubCategories?.length || sub?.Department?.length) {
              for(let subCateg of (sub?.SubCategories || sub?.Department)) {
                  if (e.target.checked) {
                  subCateg.checked = true;
                } else {
                  subCateg.checked = false;
                }
              }
            }

          }
        }
      }
      
    },
    selectAll(type, e, index) {
      this.apiResponse.Categories[0].checked = false;
      if (type == "categories") {
        let category = this.apiResponse.Categories[index];
        if (!this.cateArr.includes(category.CategoryName)) {
          this.cateArr.push(category.CategoryName);
        } else {
          let filtered = this.cateArr.filter(function(value) {
            return value != category.CategoryName;
          });
          this.cateArr = filtered;
        }
        for (let categ of category.SubCategories) {
          if (e.target.checked) {
            categ.checked = true;
            if (!this.subArr.includes(categ.value)) {
              this.subArr.push(categ.value);
            }
          } else {
            categ.checked = false;
            let filtered = this.subArr.filter(function(value) {
              return value != categ.value;
            });
            this.subArr = filtered;
          }
        }
        if(index == 0) {
          this.handleSelectAll(e, index)
        }
      } else if (type == "sectors") {
        let sector = this.apiResponse.Sectors[index];

        if (!this.sectorArr.includes(sector.Name)) {
          this.sectorArr.push(sector.Name);
        } else {
          let filtered = this.sectorArr.filter(function(value) {
            return value != sector.Name;
          });
          this.sectorArr = filtered;
        }

        for (let sec of sector.Department) {
          if (e.target.checked) {
            sec.checked = true;
            if (!this.depArr.includes(sec.value)) {
              this.depArr.push(sec.value);
            }
          } else {
            sec.checked = false;
            let filtered = this.depArr.filter(function(value) {
              return value != sec.value;
            });
            this.depArr = filtered;
          }
        }
      } else if (type == "health") {
        let health = this.apiResponse.HealthProducts[index];
        if (!this.healthArr.includes(health.Name)) {
          this.healthArr.push(health.Name);
        } else {
          let deletedItem = this.healthArr.indexOf(health.Name);
          this.healthArr.splice(deletedItem, 1);
        }
      } else if (type == "func") {
        let func = this.apiResponse.Functions[index];
        if (!this.funcArr.includes(func.Name)) {
          this.funcArr.push(func.Name);
        } else {
          let deletedItem = this.funcArr.indexOf(func.Name);
          this.funcArr.splice(deletedItem, 1);
        }
      } else if (type == "ruleCategories") {
        let rule = this.categRegulation[index];
        if (!this.ruleArr.includes(rule.CategoryName.trim())) {
          this.ruleArr.push(rule.CategoryName.trim());
        } else {
          let deletedItem = this.ruleArr.indexOf(rule.CategoryName.trim());
          this.ruleArr.splice(deletedItem, 1);
        }
      }

      // this.counter = 0;

      // for (let categ in this.apiResponse) {
      //   var obj = this.apiResponse[categ];
      //   if(obj?.length) {
      //     if(categ != "CategoriesForRules") {
      //       this.counter += obj?.length;
      //     }
      //     for(let sub of obj) {
      //       if(sub?.SubCategories?.length || sub?.Department?.length) {
      //         this.counter += (sub?.SubCategories?.length || sub?.Department?.length)
      //       }
      //     }
      //   }
      // }
      // debugger
      // if(this.counter == this.subArr.length) {
      //   this.apiResponse.Categories[0].checked = true;
      // } else {
      //   this.subArr.splice(0, 1)
      //   this.apiResponse.Categories[0].checked = false;
      // }

    },
    select(type, index, e, indexs) {
      if (type == "categories") {
        let category = this.apiResponse.Categories[index];
        let subcategory = this.apiResponse.Categories[index].SubCategories[
          indexs
        ];
        let selectAll = true;
        if (e.target.checked) {
          subcategory.checked = true;
          this.subArr.push(subcategory.value);
          if (
            this.apiResponse.Categories[index].SubCategories.length ==
            this.subArr.length
          ) {
            this.cateArr.push(category.CategoryName);
          }
        } else {
          subcategory.checked = false;
          let filteredcateArr = this.cateArr.filter(function(value) {
            return value != category.CategoryName;
          });
          this.cateArr = filteredcateArr;
          let filteredsubArr = this.subArr.filter(function(value) {
            return value != subcategory.value;
          });
          this.subArr = filteredsubArr;
        }

        for (let categ of category.SubCategories) {
          if (categ.checked == false) {
            selectAll = false;
            break;
          }
        }

        if (selectAll == true) {
          this.apiResponse.Categories[index].checked = true;
        } else {
          this.apiResponse.Categories[index].checked = false;
        }
      } else if (type == "sectors") {
        let sector = this.apiResponse.Sectors[index];
        let subSector = this.apiResponse.Sectors[index].Department[indexs];

        let selectAll = true;
        if (e.target.checked) {
          subSector.checked = true;
          this.depArr.push(subSector.value);
          if (
            this.apiResponse.Sectors[index].Department.length ==
            this.depArr.length
          ) {
            this.sectorArr.push(sector.Name);
          }
        } else {
          subSector.checked = false;
          let filteredcateArr = this.sectorArr.filter(function(value) {
            return value != sector.Name;
          });
          this.sectorArr = filteredcateArr;
          let filteredsubArr = this.depArr.filter(function(value) {
            return value != subSector.value;
          });
          this.depArr = filteredsubArr;
        }

        for (let sec of sector.Department) {
          if (sec.checked == false) {
            selectAll = false;
            break;
          }
        }

        if (selectAll == true) {
          this.apiResponse.Sectors[index].checked = true;
        } else {
          this.apiResponse.Sectors[index].checked = false;
        }
      }
    },
    sendData() {
      if (this.apiResponse.Categories[0].checked) {
        this.cateArr = [];
        this.subArr = [];
      }
      this.$emit("filterClicked", true);
      this.$emit("categoryArr", this.cateArr);
      this.$emit("sectorArr", this.sectorArr);
      this.$emit("subArr", this.subArr);
      this.$emit("healthArr", this.healthArr);
      this.$emit("funcArr", this.funcArr);
      this.$emit("depArr", this.depArr);
      this.$emit("tarckApplyFilter", (this.tarckApplyFilter = true));
      this.$emit("ruleArr", this.ruleArr);
      this.$emit("datestart", this.datestart);
      this.$emit("dateend", this.dateend);
      this.$emit("resetData", this.resetDate);

      if (window.innerWidth <= 1025) {
        this.checkMobileFilter();
      }

      setTimeout(function() {
        document.querySelector(".accordion-wrapper").scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "start",
        });
      }, 500);
    },
    checkMobileFilter() {
      this.checkMobileFilterBtn = !this.checkMobileFilterBtn;
      this.checkMobileFilterData = !this.checkMobileFilterData;
    },
    reset() {
      if (this.checkCat == "service") {
        for (let c of this.apiResponse.Categories) {
          c.checked = false;
          for (let sub of c.SubCategories) {
            sub.checked = false;
          }
        }
      }
      if (this.checkSector) {
        for (let sec of this.apiResponse.Sectors) {
          sec.checked = false;
          for (let dep of sec.Department) {
            dep.checked = false;
          }
        }
      }

      for (let item of this.apiResponse.HealthProducts) {
        item.checked = false;
      }
      for (let item of this.apiResponse.Functions) {
        item.checked = false;
      }
      for (let item of this.apiResponse.CategoriesForRules) {
        item.checked = false;
      }

      this.cateArr = [];
      this.sectorArr = [];
      this.subArr = [];
      this.depArr = [];
      this.funcArr = [];
      this.healthArr = [];
      this.ruleArr = [];
      this.datestart = "";
      this.dateend = "";
      this.$emit("categoryArr", this.cateArr);
      this.$emit("sectorArr", this.sectorArr);
      this.$emit("subArr", this.subArr);
      this.$emit("healthArr", this.healthArr);
      this.$emit("funcArr", this.funcArr);
      this.$emit("depArr", this.depArr);
      this.$emit("tarckApplyFilter", (this.tarckApplyFilter = true));
      this.$emit("ruleArr", this.ruleArr);
      this.filter();

      setTimeout(function() {
        document.querySelector(".accordion-wrapper").scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "start",
        });
      }, 500);

      if (window.innerWidth <= 1025) {
        this.checkMobileFilter();
      }
    },
    filterReszie() {
      if (window.innerWidth <= 1025) {
        this.checkMobileFilterBtn = true;
        this.checkMobileFilterData = false;
      } else {
        this.checkMobileFilterBtn = false;
        this.checkMobileFilterData = true;
      }
    },
    scrollUp() {
      document.querySelector(".filter-component").scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "start",
      });
    },
  },
  mounted() {
    this.filterReszie();
  },
};
</script>
